import { render, staticRenderFns } from "./PresaleMain.vue?vue&type=template&id=15402af8"
import script from "./PresaleMain.vue?vue&type=script&lang=js"
export * from "./PresaleMain.vue?vue&type=script&lang=js"
import style0 from "./PresaleMain.vue?vue&type=style&index=0&id=15402af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports